import { render } from "./ProductComparisonModal.vue?vue&type=template&id=eda50788"
import script from "./ProductComparisonModal.vue?vue&type=script&lang=js"
export * from "./ProductComparisonModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__